import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import PretendardText from "../atoms/text/pretendardText";
import scrollToTop from "../../util/scrollToTop";

function GoBack(props) {
  const navigate = useNavigate();
  return (
    <>
      <GoBackWrapper
        onClick={() => {
          if (props.onClick) {
            props.onClick();
          } else {
            navigate(-1);
            scrollToTop();
          }
        }}
        style={{ cursor: "pointer" }}
      >
        <img src="/assets/admin/icons/ico_arrow_left.svg" alt="뒤로가기" />
        <PretendardText
          style={{
            fontWeight: "700",
            fontSize: "16px",
            lineHeight: "28px",
            letterSpacing: "-0.3%",
            color: "#aaa",
          }}
        >
          뒤로가기
        </PretendardText>
      </GoBackWrapper>
    </>
  );
}

export default GoBack;

const GoBackWrapper = styled.div.attrs((props) => {})`
  width: 100px;
  display: flex;
  align-items: center;
  gap: 10px;
`;
